import { Link } from "react-router-dom";
import { Instagram, Mail } from "lucide-react";

export default function Footer() {
    return (
        <footer data-testid="site-footer" className="mt-24 border-t border-white/5">
            <div className="mx-auto max-w-[1600px] px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
                <div className="md:col-span-2">
                    <div className="font-display font-black text-3xl tracking-tight leading-none">
                        <span className="text-white">APNI </span><span className="text-[#FFD400]">DUKAN</span>
                    </div>
                    <p className="mt-4 max-w-md text-sm text-white/60 leading-relaxed">
                        India's AI Entertainment Platform for Web Series, Viral Videos, AI Commercials, and Cinematic AI Storytelling.
                    </p>
                    <a
                        href="mailto:linkan@yourapnidukan.com"
                        data-testid="footer-business-email"
                        className="mt-5 inline-flex items-center gap-2 text-sm text-white/80 hover:text-[#FFD400] transition-colors"
                    >
                        <Mail className="w-4 h-4 text-[#FFD400]" />
                        <span className="text-white/60">Business:</span>
                        <span className="text-[#FFD400] font-medium">linkan@yourapnidukan.com</span>
                    </a>
                </div>

                <div>
                    <h4 className="font-display font-semibold text-white mb-4">Explore</h4>
                    <ul className="space-y-2 text-sm text-white/70">
                        <li><Link to="/series" className="hover:text-[#FFD400] transition-colors">Web Series</Link></li>
                        <li><Link to="/viral" className="hover:text-[#FFD400] transition-colors">Viral Videos</Link></li>
                        <li><Link to="/ai-creative" className="hover:text-[#FFD400] transition-colors">AI Creative</Link></li>
                        <li><Link to="/coming-soon" className="hover:text-[#FFD400] transition-colors">Coming Soon</Link></li>
                    </ul>
                </div>

                <div>
                    <h4 className="font-display font-semibold text-white mb-4">Company</h4>
                    <ul className="space-y-2 text-sm text-white/70">
                        <li><Link to="/about" className="hover:text-[#FFD400] transition-colors">About</Link></li>
                        <li><Link to="/contact" className="hover:text-[#FFD400] transition-colors">Contact</Link></li>
                        <li><Link to="/privacy" className="hover:text-[#FFD400] transition-colors">Privacy</Link></li>
                        <li><Link to="/terms" className="hover:text-[#FFD400] transition-colors">Terms</Link></li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-white/5">
                <div className="mx-auto max-w-[1600px] px-6 lg:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
                    <p className="text-xs text-white/50">© 2026 Apni Dukan. All rights reserved.</p>
                    <div className="flex items-center gap-4 text-white/70">
                        <a href="https://www.instagram.com/yourapnidukan/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="hover:text-[#FFD400] transition-colors" data-testid="footer-instagram">
                            <Instagram className="w-5 h-5" />
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
}
